module.exports = __webpack_public_path__ + "static/media/blank_cheque.2d1602fe.jpg";